"use client";

import Image from "next/image";
import Link from "next/link";

interface LogoProps {
    className?: string;
    width?: number;
    height?: number;
    href?: string;
}

export function Logo({ className = "", width = 180, height = 45, href = "/" }: LogoProps) {
    return (
        <Link href={href} className={`inline-block ${className}`}>
            <Image
                src="/fullLogo.png"
                alt="Interview Flow Logo"
                width={width}
                height={height}
                priority
                className="h-auto w-auto max-h-12"
            />
        </Link>
    );
}
